import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useStore } from "@/lib/store";

export default function AuthCallback() {
  const { googleLogin } = useStore();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams((window.location.hash || "").replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/auth", { replace: true });
      return;
    }
    googleLogin(sid)
      .then((u) => {
        toast.success("Signed in with Google");
        navigate(u.role === "vendor" ? "/vendor" : u.role === "admin" ? "/admin" : "/buyer", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/auth", { replace: true });
      });
  }, [googleLogin, navigate]);

  return (
    <p className="py-24 text-center text-sm text-slate-500" data-testid="auth-callback">
      Signing you in…
    </p>
  );
}
